// ============================================================
// LEAVING MELEE (2026-10-26): who a move broke off from.
//
// Engaged means within a strike of each other - the gang-up's reading, `reachGap <= DEFAULT_REACH_M`. A move that
// starts engaged with someone and ends out of their reach has left melee with them; without a Disengage that is a
// free strike in the book, which the table leaves to the GM (a reminder line, nothing rolled - the user's ruling).
//
// Pure. Zero React dependency.
// ============================================================
import type { Token } from './tokens';
import { DEFAULT_REACH_M, inMelee } from './reach';

/** Everyone in `others` within a strike of `at`. */
export function engagedWith(at: Token, others: readonly Token[], reach = DEFAULT_REACH_M): string[] {
  return others.filter((o) => o.id !== at.id && inMelee(at, o, reach)).map((o) => o.id);
}

/** Who the move from `from` to `to` broke off from: engaged before, out of reach after. */
export function leftMelee(from: Token, to: Token, others: readonly Token[], reach = DEFAULT_REACH_M): string[] {
  const after = new Set(engagedWith(to, others, reach));
  return engagedWith(from, others, reach).filter((id) => !after.has(id));
}
